import { formatPercentageChange } from "../utils/formatUtils";
import UpIcon from "../assets/green-tri.svg";
import DownIcon from "../assets/red-tri.svg";

export default function ChangeIndicator({ value }) {
  const isPositive = value >= 0;
  const Icon = isPositive ? UpIcon : DownIcon;
  return (
    <>
      <div className={`hidden lg:flex justify-end items-center ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
        <img src={Icon} alt={isPositive ? 'Up' : 'Down'} className="w-4 h-4 mr-[2px] lg:mr-2" />
        {formatPercentageChange(value, false)}
      </div>
      <p className={`lg:hidden ${isPositive ? 'text-green-500' : 'text-red-500'}`}>{formatPercentageChange(value, true)}</p>
    </>
  );
}